module.exports = __webpack_public_path__ + "static/media/background-line.a628c200.png";